import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container } from "react-bootstrap";

import "./styles.scss";

const Information = () => (
  <div className="information">
    all orders and contracts for the supply by dpd of carrier services shall be
    governed by its standard terms & conditions of trading.
  </div>
);

const TermsAndConditions = ({ href, ...otherProps }) => {
  return (
    <a href={href} className="copyright" {...otherProps}>
      DPD is a trading division of DPDgroup. Registered office: PO BOX 6979,
      Roebuck Lane, Smethwick, West Midlands, B66 1BN. Registered in England and
      Wales No. 732993
    </a>
  );
};

TermsAndConditions.propTypes = {
  href: PropTypes.string,
};

const Copyright = ({ className, ...restProps }) => {
  return (
    <Container className={classNames("mydpd-copyright text-center", className)}>
      <Information />
      <TermsAndConditions {...restProps} />
    </Container>
  );
};

Copyright.propTypes = {
  className: PropTypes.string,
  ...TermsAndConditions.propTypes,
};

Copyright.TermsAndConditions = TermsAndConditions;
Copyright.Information = Information;

export default Copyright;
